import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const WHITE_COLOR = /^#(?:f{3}|f{6}|f{8})$/i;
const FALLBACK_COLOR = '#D4D4D8';

const getCategoryCardColor = (color) => (
  color && !WHITE_COLOR.test(color.trim()) ? color : FALLBACK_COLOR
);

const ScheduleCategoryCard = forwardRef(({
  color,
  className,
  style,
  children,
  ...rest
}, ref) => (
  <div
    ref={ref}
    className={`schedule-category-card${className ? ` ${className}` : ''}`}
    style={{
      ...style,
      '--category-color': getCategoryCardColor(color),
    }}
    {...rest}
  >
    {children}
  </div>
));

ScheduleCategoryCard.displayName = 'ScheduleCategoryCard';

ScheduleCategoryCard.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  children: PropTypes.node,
};

ScheduleCategoryCard.defaultProps = {
  color: null,
  className: '',
  style: {},
  children: null,
};

export default ScheduleCategoryCard;
